import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Popup } from '../../interfaces/Popup/Popup';
import { getPopups } from '../../api/Popup';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { PopupsTable } from './PopupsTable';

export const PopupsPage = () => {
  const navigate = useNavigate();

  const [popups, setPopups] = useState<Popup[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshPopups = () => {
    setLoading(true);
    getPopups()
      .then((p) => setPopups(p))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshPopups();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Pop-up'lar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/visual/popups/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Pop-up
      </Button>
      <PopupsTable popups={popups} />
    </Box>
  );
};
